import { useState } from 'react'
import { languageName, STAFF_LANGUAGES, isStaffLanguage } from '../lib/staffText'
import { Select } from './Select'
import { useLanguageChoice, useStaffText } from './StaffText'

/**
 * The language of the staff screens, chosen from the top bar.
 *
 * This is the only place a language is chosen. It sits in the same corner of every
 * staff screen — the sign-in screen and the new-password wall included, which have
 * no bar of their own — so a person who cannot read the screen in front of them
 * finds it where they found it last time, without first having to read their way
 * to a settings page.
 *
 * Each language is written in its own name: a reader looking for Русский is not
 * helped by the word "Russian".
 */
export function LanguageMenu() {
  const { lang, say } = useStaffText()
  const choose = useLanguageChoice()
  const [busy, setBusy] = useState(false)
  if (!choose) return null
  return (
    <Select
      aria-label={say('entry.language')}
      title={say('entry.language')}
      size="sm"
      className="lang-menu"
      style={{ width: 'auto' }}
      value={lang}
      disabled={busy}
      options={STAFF_LANGUAGES.map((code) => ({ value: code, label: languageName(code), short: code.toUpperCase() }))}
      onChange={(value) => {
        if (!isStaffLanguage(value) || value === lang) return
        setBusy(true)
        choose(value).finally(() => setBusy(false))
      }}
    />
  )
}
